var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.active_layout,{tag:"component"}),_c('b-icon',{staticClass:"rounded-circle p-2 scroll_to_top bg-dark text-white",class:{show_scroll: _vm.check_scroll_offset},attrs:{"icon":"file-arrow-up"},on:{"click":_vm.scroll_to_top}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }